import React from 'react';
import { Text } from 'braid-design-system';
import type { PrintPaperSize } from '../../utils/posPrintRenderer';

interface PrintSizeToggleProps {
  value: PrintPaperSize;
  onChange: (paperSize: PrintPaperSize) => void;
  disabled?: boolean;
  /** When true, only the POS option is disabled (e.g. tax invoices must print A4). */
  disablePos?: boolean;
  label?: string;
}

const PrintSizeToggle: React.FC<PrintSizeToggleProps> = ({
  value,
  onChange,
  disabled = false,
  disablePos = false,
  label = 'Print size',
}) => {
  return (
    <div className="billing-print-size-switch">
      <span className="billing-print-size-label">
        <Text size="small" weight="strong">
          {label}
        </Text>
      </span>
      <div className="billing-print-size-options" role="group" aria-label={label}>
        <button
          type="button"
          className={`billing-print-size-btn ${value === 'POS' ? 'billing-print-size-btn-active' : ''}`}
          onClick={() => onChange('POS')}
          disabled={disabled || disablePos}
          title={disablePos ? 'Tax invoices must be printed in A4' : undefined}
        >
          POS
        </button>
        <button
          type="button"
          className={`billing-print-size-btn ${value === 'A4' ? 'billing-print-size-btn-active' : ''}`}
          onClick={() => onChange('A4')}
          disabled={disabled}
        >
          A4
        </button>
      </div>
    </div>
  );
};

export default PrintSizeToggle;
